import { AbstractGenericPagedClientManager } from "./AbstractGenericPagedClientManager";
import { TLCRest } from "../rest/REST";
import { TLCLogger } from "../logger";

export class GenericRESTPagedClientManager extends AbstractGenericPagedClientManager {
	constructor(options, restOptions) {
		super(options);

		this.restUrl = options.restUrl;
		this.restOptions = restOptions || {};
	}

	fireSearch() {
		throw("GenericRESTPagedClientManager.fireSearch must be overridden");
	}

	search() {
		var args = Array.prototype.slice.call(arguments),
			_this = this,
			newOptions = $.extend({
				callback: function (data) {
					_this.successHandler(data);
				},
				error: function (e) {
					TLCLogger.log("Paging Model Error");
					TLCLogger.log(e);
					_this.errorHandler(e);
				}
			}, this.restOptions);

		var restUrl = this.restUrl;

		if (args.length == 1 && typeof args[0] == 'object') {
			newOptions.postData = args[0];
		} else {
			if (restUrl.charAt(restUrl.length - 1) != "/") {
				restUrl += "/";
			}
			restUrl += args.join("/");
		}
		TLCRest.jsonCall(restUrl, newOptions);
	}

}